<template>
  <div>
    <Input
      @on-focus="openGroup = true"
      :value="name"
      readonly
      placeholder="请选择"
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openGroup"
      width="450"
      draggable
      class="my-drawer"
    >
      <alarm-tool @alarmData="reAlarmData" :isMore="true"></alarm-tool>
    </Drawer>
  </div>
</template>
<script>
import alarmTool from "./alarmSafeTool.vue";
export default {
  components: { alarmTool },
  props: ["placement"],
  data() {
    return {
      openGroup: false,
      name: "",
      deviceIdList: [],
    };
  },
  methods: {
    reAlarmData(v) {
      console.log(v);

      this.name = "选择" + v.length + "种报警";
      this.$emit("alarmIdList", v);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ../common/src/components/common/selecAlotAlarmSafe.vue